export enum TrafficSource {
  'online'= 'online',
  'web-page'= 'web-page',
  'luki-app'= 'luki-app',
  'store'= 'store',
}
